var XPortal = XPortal || {};
XPortal.NotifyTemplateEditor = (function () {
    var self = {
        ControlSelector: ".xpand-templateid", Editors: [],
        Init: function (selector) {
            var container = $(selector ? selector : ".detail-page");
            container.find(XPortal.NotifyTemplateEditor.ControlSelector).each(function (i, element) {
                XPortal.NotifyTemplateEditor.initFor($(element), XPortal.Store.getModelName(container[0].id),container);
            });
        },
        initFor: function (el, modelName, container) {
            const sttgs = XPortal.Main.GetSettingsFor(el);

            showHide(sttgs.allowcustomization && sttgs.allowcustomization == "1", sttgs.titlefield);
            showHide(sttgs.allowcustomization && sttgs.allowcustomization == "1", sttgs.descriptionfield);
            var editorInfo = { field: sttgs.fieldname, type: sttgs.templatetype, element: el, sttgs, modelName, container };
            self.Editors.push(editorInfo);
            self.reInitFor(editorInfo, [{ Title: sttgs.value }]);
            self.InitPreview(editorInfo, modelName);
        },
        reInitFor: function (editorInfo, templates) {
            var el = getElementBy(editorInfo);
            var mbox = el.data("kendoComboBox");
            if (mbox) mbox.destroy();
            editorInfo.sttgs.templates = templates;
            editorInfo.sttgs.dataSource = { data: templates.map(function (ti) { return getTemplateTitle(ti); }) };
            editorInfo.sttgs.suggest = false;
            editorInfo.sttgs.highlightFirst = false;
            editorInfo.sttgs.autoBind = true;
            editorInfo.sttgs.ignoreCase = true;
            editorInfo.sttgs.change = function (e) {
                e.preventDefault();
                self.UpdateSelectValue(editorInfo, editorInfo.sttgs.templates,true);
            };
            editorInfo.sttgs.value = null;
            delete editorInfo.sttgs.value;
            editorInfo.sttgs.value = el.kendoComboBox(editorInfo.sttgs);
        },
        updateDataSource: function (editorInfo, templates) {
            //showHide(templates && templates.length > 1, editorInfo.field);
            self.reInitFor(editorInfo, templates);          
            self.UpdateSelectValue(editorInfo, templates,false);
        },
        UpdateSelectValue: function (editorInfo, templates, requiredToUpdate) {
            var el = getElementBy(editorInfo);
            var mbox = el.data("kendoComboBox");            
            var valToSelect = getCurrentTemplate(editorInfo, templates);
            var valExists = false;
            if (!valToSelect) valToSelect = templates[0]; else valExists = true;
            curVal = getTemplateTitle(valToSelect);
            if (mbox) mbox.value(curVal);
            if (el.val() == curVal && !requiredToUpdate) return;
            el.val(curVal);
            DispatchEvents(editorInfo.modelName, editorInfo.sttgs, curVal, valToSelect.Subject, valToSelect.Message);
        },
        InitPreview: function (staticEditorInfo, modelName) {            
            var onClick = function (e) {
                var editorInfo = staticEditorInfo;//?update
                var curTemplate = getCurrentTemplate(editorInfo, editorInfo.sttgs.templates);
                var title = $(this).attr("data-title");
                var description = $(this).attr("data-description");
                
                getTemplatePreview(editorInfo, curTemplate, modelName, function (data) {
                    XPortal.Modal.alert({
                        modalType: "sm-width",
                        headerText: title ? title : getTemplateTitle(curTemplate),
                        alertText: `<div class='notif-tmpl-description'> ${description} </div>
                                    <div class='notif-tmpl-wrapper'>
                                        <div class='notif-tmpl-subject'> ${data.Subject} </div>
                                        <div class='notif-tmpl-message'> ${data.Message} </div>
                                    </div>`
                    });
                });
            };
            var el = getElementBy(staticEditorInfo);
            el.closest(".ntemplate-econtainer").find(".btn-preview-template").off("click");
            el.closest(".ntemplate-econtainer").find(".btn-preview-template").on("click", onClick);
        }
    };
    self.UpdateTemplates = function (data) {
        if (data.Templates == null)
            return;
        var ntemplates = data.Templates.notifytemplates;
        var mtemplates = data.Templates.mailtemplates;
        self.Editors.forEach(function (ei) {
            if (ei.type.toLowerCase().indexOf("mail") > -1)
                self.updateDataSource(ei, mtemplates);
            else
                self.updateDataSource(ei, ntemplates);
        });
    };
    function showHide(isShow, fieldName) {
        if (!fieldName) return;
        var el = $("[data-metadata-fieldname=" + fieldName + "]").closest(".form-group");
        if (isShow) el.show(); else el.hide();
    };
    function getElementBy(editorInfo) {
        var el = $("[data-metadata-fieldname=" + editorInfo.field + "]")
        return el;
    };
    function getTemplateTitle(xtemplate) {
        var r = xtemplate ? xtemplate.Title : null;
        if (!r || r.length < 1) r = xtemplate.Subject;
        return (!r || r.length < 1) ? "" : r;
    };
    function DispatchEvents(modelName, sttgs, templateId, title, description) {
        XPortal.Store.DispatchNoAutoSave(modelName, sttgs.titlefield, title ? title: "");
        XPortal.Store.DispatchNoAutoSave(modelName, sttgs.descriptionfield, description ? description : "");     
        XPortal.Store.DispatchByName(modelName, sttgs.fieldname, templateId ? templateId : "");
    };
    function getCurrentTemplate(editorInfo, templates) {
        var el = getElementBy(editorInfo);
        var mbox = el.data("kendoComboBox");
        var curVal = mbox ? mbox.value() : el.val();
        curVal = curVal ? curVal.toLowerCase() : "";
        if (!curVal) {
            const fields = XPortal.Store.GetModelByName(editorInfo.modelName).entity.Fields;
            var fld = fields.find(x => x.Name == editorInfo.field);
            curVal = fld ? fld.StringValue.toLowerCase() : curVal;
        }
        var valToSelect = templates.find(function (x) { return getTemplateTitle(x).toLowerCase() == curVal; });
        return valToSelect;
    };
    function getTemplatePreview(editorInfo, curTemplate, modelName,  onCallBack) {
        const container = editorInfo.container;
        const el = getElementBy(editorInfo);
        const relatedListId = $("[data-metadata-fieldname=RelatedListId]").val();
        const model = XPortal.Store.GetModelByName(modelName);
        const entity = XPortal.Store.ConvertEditEntityToSave(model.entity);
       
        curTemplate.Subject = entity.Fields.find(function (f) { return f.Field == editorInfo.sttgs.titlefield; }).Data;
        curTemplate.Message = entity.Fields.find(function (f) { return f.Field == editorInfo.sttgs.descriptionfield; }).Data;
        XPortal.EntityFilterPicker.Call({
            url: editorInfo.sttgs.previewsrc, container: container, valueControl: null,
            data: JSON.stringify({ NodeId: model.model.NodeId, RelatedPageId: relatedListId, Template: curTemplate, Entity: entity, TemplateType: editorInfo.type })
        }, function (d, r) { onCallBack(r.Templates == null ? "TMPL" : r.Templates.template); });
    };
    return self;
}());
